import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, Check, Trash2 } from "lucide-react";

export default function AdminMessages() {
  const [items, setItems] = useState([]);

  const load = async () => { const { data } = await api.get("/admin/messages"); setItems(data || []); };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/messages/${id}/read`, {});
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Löschen?")) return;
    await api.delete(`/admin/messages/${id}`);
    load();
  };

  const unread = items.filter((m) => !m.read).length;

  return (
    <div className="p-5 sm:p-8 lg:p-10" data-testid="admin-messages-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-3xl sm:text-4xl text-ink flex items-center gap-3"><Mail className="w-6 h-6 sm:w-7 sm:h-7 text-terracotta" strokeWidth={1.5} /> Nachrichten</h1>
        {unread > 0 && <span className="px-3 py-1.5 rounded-full bg-terracotta/10 text-terracotta text-xs uppercase tracking-wider" data-testid="msg-unread-count">{unread} neu</span>}
      </div>

      <div className="mt-8 space-y-3">
        {items.length === 0 && <div className="text-center py-16 text-ink-muted">—</div>}
        {items.map((m) => (
          <article key={m.id} className={`bg-white border rounded-md p-5 ${m.read ? "border-border" : "border-terracotta/40 bg-terracotta/5"}`} data-testid={`msg-${m.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="font-display text-xl text-ink">{m.name}</h3>
                  {!m.read && <span className="text-[10px] uppercase tracking-widest text-terracotta bg-terracotta/15 px-2 py-0.5 rounded-full">Neu</span>}
                </div>
                <div className="mt-1 flex items-center gap-3 text-xs text-ink-muted">
                  <a href={`mailto:${m.email}`} className="hover:text-terracotta">{m.email}</a>
                  {m.phone && <><span>·</span><a href={`tel:${m.phone}`} className="hover:text-terracotta">{m.phone}</a></>}
                  <span>·</span>
                  <span>{(m.created_at || "").replace("T", " ").slice(0, 16)}</span>
                </div>
              </div>
              <div className="flex gap-1">
                {!m.read && (
                  <button onClick={() => markRead(m.id)} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs rounded hover:bg-sage/15 text-sage" data-testid={`msg-read-${m.id}`}>
                    <Check className="w-3.5 h-3.5" strokeWidth={1.5} /> Gelesen
                  </button>
                )}
                <a href={`mailto:${m.email}?subject=${encodeURIComponent('Re: Deine Nachricht – Ayurveda Aargau')}`} className="inline-flex items-center gap-1.5 px-3 py-2 text-xs rounded border border-border hover:bg-muted text-ink" data-testid={`msg-reply-${m.id}`}>
                  Antworten
                </a>
                <button onClick={() => del(m.id)} className="p-2 rounded hover:bg-muted text-ink-muted" data-testid={`msg-del-${m.id}`}><Trash2 className="w-4 h-4" strokeWidth={1.5} /></button>
              </div>
            </div>
            <p className="mt-4 text-ink leading-relaxed whitespace-pre-wrap text-sm">{m.message}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
